<template>
<div>
    <v-card flat color="transparent" class="mt-7">
        <v-toolbar  class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title>{{$t('animal.performance')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                large
                :to="{ name: 'AnimalPerformanceEdit', params: {animal_number: $route.params.animal_number}}"
            >
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <!-- <v-btn
                icon
                large
            >
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
        </v-toolbar>
    </v-card>
    <v-card flat class="mt-7">
    <v-card-text>
    <div class="tabs-section">
        <template>
            <v-tabs class="tabs-pill" v-model="tab">
                <v-tab v-if="currentAnimal.animalType == 'dam'">{{$t('animal.performanceInfo.milk')}}</v-tab>
                <v-tab>{{$t('animal.performanceInfo.liveweight')}}</v-tab>
                <v-tab>{{$t('animal.performanceInfo.score')}}</v-tab>
                <v-tab>{{$t('animal.performanceInfo.fertility')}}</v-tab>
                <v-tab>{{$t('animal.performanceInfo.measurements')}}</v-tab>
            </v-tabs>
        </template>
    </div>
    <v-tabs-items v-model="tab">
        <v-tab-item v-if="currentAnimal.animalType == 'dam'"> <milk :animal="animal"></milk> </v-tab-item>
        <v-tab-item> <liveweight :animal="animal" :current-animal="currentAnimal" /> </v-tab-item>
        <v-tab-item> <score :animal="animal" /> </v-tab-item>
        <v-tab-item> <fertility :animal="animal" /> </v-tab-item>
        <v-tab-item> <measurements :animal="animal"/> </v-tab-item>
    </v-tabs-items>
    </v-card-text>
</v-card>
</div>
</template>
<script>
import AnimalService from "@/_services/AnimalService"

import Milk from "./performance/Milk.vue"
import Liveweight from "./performance/Liveweight.vue"
import Score from "./performance/Score.vue"
import Fertility from "./performance/Fertility.vue"
import Measurements from "./performance/Measure.vue"

export default {
    components: {
        Milk,
        Liveweight,
        Score,
        Fertility,
        Measurements
    },
    created() {
        const fetchData = async () => {
            this.getAnimalPerformance(this.$route.params.animal_number)
        }
        fetchData();
    },
    props: {
        currentAnimal: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            animal: {},
            tab: null,
        }
    },

    methods: {
        getAnimalPerformance(animalId) {
            AnimalService.getAnimalPerformance(animalId)
            .then( res => {
                this.animal =res.data.animalPerformance;
            })
            .catch(err => {
                if(err.data.code === 422)
                  this.$router.push({ name: 'AnimalPerformanceEdit', params: { animal_number: this.$route.params.animal_number }})
            })
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>